import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import './ConsoleFragments.css';

export default function ConsoleCard({ className, ...props }) {
    if (props.onSubmit) {
        return <form className={cn('ConsoleCard', className)} {...props} />;
    }

    return <div className={cn('ConsoleCard', className)} {...props} />;
}

ConsoleCard.propTypes = {
    onSubmit: PropTypes.func,
};
